class User {
  id = null;
  name = "";
  email = "";
  username = "";
  password = "";
  startdate = null;
  agencyid = null;
  roleid = null;
  phone = null;
  maxdiscount = 0;
  candominussales = false;
  lang = "en";

  static getFormData(object, isPutMethod = false) {
    console.log("creating form data ....");
    const formData = new FormData();
    if (object.profilepicture) {
      formData.append("profilepicture", object.profilepicture);
    }
    formData.append("name", object.name);
    formData.append("email", object.email);
    formData.append("username", object.username);
    if (object.password) {
      formData.append("password", object.password);
    }
    formData.append("startdate", object.startdate);
    if (object.agencyid) {
      formData.append("agencyid", object.agencyid);
    }
    if (object.roleid || object.roleid === 0) {
      formData.append("roleid", object.roleid);
    }
    if (object.permissions) {
      formData.append("permissions", JSON.stringify(object.permissions));
    }
    formData.append("active", "true");
    if (object.agencyid === 1) {
      formData.append("candominussales", object.candominussales);
      formData.append("maxdiscount", object.maxdiscount);
    }

    if (object.roleid === 2) {
      formData.append("maxdiscount", object.maxdiscount);
    }
    if (object.phone) {
      formData.append("phone", object.phone);
    }
    formData.append("lang", object.lang);
    if (isPutMethod) {
      formData.append("_method", "PUT");
    }
    return formData;
  }
}

export default User;
